import * as React from 'react';
import Strings from '../../globals/Strings';

export default ({progress}: UploadProgressBarProps) => (
   <div className="upload-progress-container">
      <div className="progress-bar-total">
         <div className="progress-bar-progress" style={{width: `${Math.round(progress * 1000) / 10}%`}}></div>
      </div>
      <div>{Strings.labels.fileImporter.uploadInProgress}</div>
   </div>
);

interface UploadProgressBarProps {
   progress: number;
}
